module.exports = __webpack_public_path__ + "static/new-map-small-bd80d58d3b0afe4c1508faac276eff7d.png";